import { LOCATION_THEMES } from '@utils/location-themes'

export function applyLocationTheme(locationUUID: string, document: Document): void {
	const theme = LOCATION_THEMES[locationUUID]

	if (!theme) return

	Object.entries(theme).forEach(([property, value]) =>
		document.documentElement.style.setProperty(property, value)
	)
}
